import { characterSelectionScene } from './character-selection-scene';
import { crowdCutsceneScene } from './crowd-cutscene';
import { crowdScene } from './crowd-scene';
import { gameOverScene } from './game-over-scene';
import { languageSelectionScene } from './language-selection-scene';
import { splashScene } from './splash-scene';

export function registerScenes() {
  splashScene();
  characterSelectionScene();
  languageSelectionScene();
  crowdCutsceneScene();
  crowdScene();
  gameOverScene();
  // TODO: end cut-scene
  // removed for the initial launch of the game during the game jam.
  // mazeScene();
  // townScene();
}
